import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import Footer from '../NewApply/Footer';
import Header from '../NewProfile/Header';
import ScrollLock from 'react-scrolllock';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { Redirect } from 'react-router-dom';
import HelpPage from './HelpPage';
import { faCircle } from '@fortawesome/pro-regular-svg-icons';
import Button from '../../artzu-ui/src/Button';
import Modal from '../../artzu-ui/src/Modal';
import AccountPending from '../../images/Icons/account-pending.svg'
import MapPin from '../../images/Icons/map-pin.svg'
import TlcPending from '../../images/Icons/tlc-pending.svg'
import PendingReactivation from '../../images/Icons/pending-reactivation.svg'

import { withApollo } from 'react-apollo';

import gql from 'graphql-tag';

import './dashboard.css';

class NewDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headerTitle: 'Dashboard',
      helpOpen: false,
      pageOpen: '',
      deactivateAccount: false,
    };
  }

  getContent = () => {
    const { status, existing_uber_partner } = this.props;
    return [
      {
        title: 'Documents Under Review',
        text:
          'Our team is reviewing your documents for eligibility and will let you know the next steps within 1-2 business days.',
        status: this.getIcon(true),
        class: this.getClass(2),
        pageName: 'appSubmitted',
      },
    ];
  };

  getIcon = status => <FontAwesomeIcon className="dashboard__icon" icon={status ? faCheckCircle : faCircle} />;

  openPage = (name, title) => this.setState({ pageOpen: name, helpOpen: true, headerTitle: title });

  closePage = () => this.setState({ helpOpen: false, headerTitle: 'Dashboard' });

  getClass = status => {
    switch (status) {
      case 1:
        return 'done';
      case 2:
        return 'current';
      default:
        return 'waiting';
    }
  };

  mapStatus = status => {
    switch (status) {
      case 'signed_up':
      case 'account_pending':
        return 1;
      case 'bgc_pending':
      case 'fleet_pending':
        return 2;
      case 'ptc_pending':
        return 3;   
      default:
        return 4;
    }
  };

  REOPEN_ACCOUNT = gql`
    mutation reopenUser {
      reopenUser {
        user {
          fullName
          status
        }
        errors {
          message
        }
      }
    }
  `;

  CLOSE_ACCOUNT = gql`
    mutation closeUser {
      closeUser {
        user {
          fullName
          status
        }
        errors {
          message
        }
      }
    }
  `;

  toggleClose = () => {
    this.props.client
      .mutate({
        mutation: this.props.status === 'closed' ? this.REOPEN_ACCOUNT : this.CLOSE_ACCOUNT,
      })
      .then(() => this.props.loadData());
  };

  contentSelector = () => {
    const { status, tlc_number, via_status } = this.props;
    if (["account_pending", "signed_up"].includes(status) && via_status !== "active_driver") {
      return (
        <Fragment>
          <div className="dashboard__container--notice">
            {' '}
            Your Autzu account has been approved - there is just one more step remaining!
                    </div>
          <img className="dashboard__container--image" src={AccountPending} style={{maxWidth: "350px"}} />
          <div className="dashboard__container--notice">
            Please visit the Via Driver's Centre to activate your Via driver account. 
            Once your Via account is active, your Autzu account will be activated 
            and you will be able to start drivesharing right away!
          </div>
          <div className="dashboard__container--via-locations">
            <div className="dashboard__container--via-centre">
              <img src={MapPin} />
              <div>Via LIC</div>
              <a href="https://www.google.ca/maps/place/Unique+Settings+of+New+York/@40.742834,-73.9376227,17z/data=!3m1!4b1!4m5!3m4!1s0x89c25ed351a83299:0x5971684b436caf6f!8m2!3d40.74283!4d-73.935434" target="_blank">
                31-00 47th Avenue, 2nd Floor, Long Island City, NY 11101
              </a>
            </div>
            <div className="dashboard__container--via-centre">
              <img src={MapPin} />
              <div>Via Bronx</div>
              <a href="https://www.google.ca/maps/place/1702+Bryant+Ave,+The+Bronx,+NY+10460,+USA/@40.8361755,-73.8872028,17z/data=!3m1!4b1!4m5!3m4!1s0x89c2f4f44760aecf:0x5178a402b1fbc51a!8m2!3d40.8361715!4d-73.8850141" target="_blank">
                1702 Bryant Avenue, The Bronx, NY 10460
              </a>
            </div>
          </div>
        </Fragment>
      )
    } else if (status === "tlc_pending" && !tlc_number) {
      return (
        <Fragment>
          <div className="dashboard__container--title">
            {' '}
            Your application has been successfully submitted and is currently being processed.
                    </div>
          {this.getContent().map(element => (
            <div className={`dashboard__item dashboard__item--${element.class}`}>
              {' '}
              {element.status}{' '}
              <div className="dashboard__item--content">
                <div className="dashboard__item--title"> {element.title} </div>{' '}
                <div className="dashboard__item--text"> {element.text}</div>
              </div>
            </div>
          ))}
        </Fragment>
      )
    } else {
      return (
        <Fragment>
          <div className="dashboard__container--title">
            {' '}
            Your application has been successfully submitted and is currently being processed.
                    </div>
          {this.getContent().map(element => (
            <div className={`dashboard__item dashboard__item--${element.class}`}>
              {' '}
              {element.status}{' '}
              <div className="dashboard__item--content">
                <div className="dashboard__item--title"> {element.title} </div>{' '}
                <div className="dashboard__item--text"> {element.text}</div>
              </div>
            </div>
          ))}
        </Fragment>
      )
    }
  }

  toggleDeactivateModal = () => this.setState({ deactivateAccount: !this.state.deactivateAccount });

  render() {
    const { history, status } = this.props;
    const { headerTitle, helpOpen, pageOpen } = this.state;
    if (status === 'operating') return <Redirect to="/dashboard" />;
    return (
      <Fragment>
        <div className="apply__progress--header">
          <div className="apply__progress--header-content container">
            <Header
              title={headerTitle}
              persistentTitle
              disable
              back
              onClick={() => (helpOpen ? this.closePage() : history.goBack())}
            />
          </div>
        </div>
        {/* { ["account_pending", "pending_reactivation"].includes(status) ? null :  */}
        <Footer
          label="Contact Us"
          back
          active
          onBackClick={() => (helpOpen ? this.closePage() : history.goBack())}
          onNextClick={() => history.push('./contact')}
        />
        <Modal open={this.state.deactivateAccount}>
          <div className="profile__deactivate-account">
            {' '}
            <div className="profile__deactivate-account--text">
              {' '}
              {status === 'closed'
                ? 'Your request will be processed in 1-2 business days. We will contact you about next steps.'
                : 'Deactivating your Autzu account will prevent you from being able to book vehicles. You can reactivate your account at any time!'}{' '}
            </div>
            <div className="profile__deactivate-account--actions">
              <Button
                className="profile__deactivate-account--button"
                label="Cancel"
                onClick={() => this.toggleDeactivateModal()}
                color="#414141"
              />{' '}
              <Button
                className="profile__deactivate-account--button"
                label={status === 'closed' ? 'Reactivate' : 'Deactivate'}
                onClick={() => {
                  this.toggleClose();
                  this.toggleDeactivateModal();
                }}
              />
            </div>
          </div>
        </Modal>
        <div className="apply">
          <div className="apply__body container apply__body--progress">
            <ScrollLock>
              <div className="dashboard__container">
                {helpOpen ? (
                  <HelpPage name={pageOpen} closePage={this.closePage} />
                ) : this.contentSelector()}
              </div>
            </ScrollLock>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default withApollo(withRouter(NewDashboard));



// WEBPACK FOOTER //
// ./src/components/NewDashboard/NycDashboard.js